export enum PreferencesSettings {
	CrossSell = "CrossSell",
}
